import { HttpErrorResponse, HttpHeaders, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError, timeout } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';

let lastReportAt = 0;

// Runs outside auth so recovered 401s are not reported. Reporting uses next(),
// bypassing this interceptor to prevent recursive reports.
export const diagnosticsInterceptor: HttpInterceptorFn = (request, next) => {
  const router = inject(Router);
  const base = environment.apiBaseUrl.replace(/\/$/, '');
  if (!request.url.startsWith(`${base}/`) || request.url.startsWith(`${base}/client-diagnostics`)) {
    return next(request);
  }
  const requestId = crypto.randomUUID();
  const route = router.url.split(/[?#]/)[0];
  const tracked = request.clone({ setHeaders: { 'X-Client-Request-Id': requestId } });
  return next(tracked).pipe(catchError((error: unknown) => {
    const now = Date.now();
    if (error instanceof HttpErrorResponse && now - lastReportAt >= 5000) {
      lastReportAt = now;
      let fileCount = 0;
      let fileBytes = 0;
      if (request.body instanceof FormData) {
        request.body.forEach(value => {
          if (value instanceof Blob) { fileCount++; fileBytes += value.size; }
        });
      }
      const path = new URL(request.url, location.origin).pathname.slice(0, 512);
      next(new HttpRequest('POST', `${base}/client-diagnostics`, {
        requestId, path, method: request.method, status: error.status,
        fileCount, fileBytes, online: navigator.onLine,
      }, { headers: new HttpHeaders({ 'X-Client-Route': route }) }))
        .pipe(timeout(5000)).subscribe({ error: () => { /* Best effort; preserve original failure. */ } });
    }
    return throwError(() => error);
  }));
};
